export default "__VITE_ASSET__C1QMVg8V__"